import * as React from 'react'
import FlexView from '@/modules/shared/components/FlexView'

import { useDrag } from 'react-dnd'
import { getEmptyImage } from 'react-dnd-html5-backend'
import { EventModel } from 'app/models/newDelegation/eventModel'
import { getEventTypeIcon } from 'app/common/converters/newDelegation/tripEventTypeToIconConverter'
import { getTripEventTypeName } from 'app/common/converters/newDelegation/tripEventTypeToTextConverter'
import { FaIcon } from '@/lib/fa'
import Tooltip from '@/modules/drivers/shared/ToolTip'

type DelegationMarkerProps = {
  canDrag: boolean
  delegationMarker: EventModel

  translate: (text: string) => string
}

const DelegationMarker = ({
  canDrag,
  delegationMarker,
  translate,
}: DelegationMarkerProps) => {
  const [{ isDragging }, dragRef, previewRef] = useDrag({
    type: 'DELEGATION_MARKER',
    item: () => ({
      ...delegationMarker,
      isDragging: true,
      translate,
    }),
    canDrag: () => canDrag,
    isDragging: (monitor) => {
      const item: any = monitor.getItem()
      return item?.tripEvent === delegationMarker.tripEvent
    },
    end: (item: any, monitor) => {
      if (!monitor.didDrop()) return
      item.isDragging = false
    },
    collect: (monitor) => ({ isDragging: monitor.isDragging() }),
  })

  // podgląd przeciągania rysuje CustomDragLayer, więc domyślny obrazek gasimy
  React.useEffect(() => {
    previewRef(getEmptyImage(), { captureDraggingState: true })
  }, [previewRef])

  return (
    <div
      ref={(node) => {
        dragRef(node)
      }}
      style={{ opacity: isDragging ? 0.5 : 1 }}
    >
      <Tooltip text={getTripEventTypeName(delegationMarker.tripEvent, translate)}>
        {canDrag && (
          <FlexView
            hAlignContent="center"
            vAlignContent="center"
            style={{
              marginLeft: 5,
              marginRight: 5,
              cursor: 'move',
              opacity: isDragging ? 0.5 : 1,
            }}
          >
            <FaIcon
              icon={getEventTypeIcon(delegationMarker.tripEvent)}
              className="cursor-pointer tw-h-4 tw-w-4 tw-text-primary"
              title={getTripEventTypeName(delegationMarker.tripEvent, translate)}
            />
          </FlexView>
        )}
      </Tooltip>
    </div>
  )
}

export default DelegationMarker
